import { createTheme } from "@mui/material/styles";

// Color palette from https://coolors.co/38023b-a288e3-bbd5ed-cefdff-ccffcb
const colors = {
  darkPurple: '#38023B',
  lightPurple: '#A288E3',
  lightBlue: '#BBD5ED',
  cyan: '#CEFDFF',
  mint: '#CCFFCB',
  white: '#FFFFFF',
  lightGray: '#F8FAFC',
  text: {
    primary: '#1A2027',
    secondary: '#3E5060',
    disabled: '#9E9E9E',
  },
};

const theme = createTheme({
  palette: {
    primary: {
      main: colors.darkPurple,
      contrastText: colors.white,
    },
    secondary: {
      main: colors.lightPurple,
      contrastText: colors.white,
    },
    info: {
      main: colors.lightBlue,
      contrastText: colors.darkPurple,
    },
    success: {
      main: colors.mint,
      contrastText: colors.darkPurple,
    },
    background: {
      default: colors.white,
      paper: colors.lightGray,
    },
    text: {
      primary: colors.text.primary,
      secondary: colors.text.secondary,
      disabled: colors.text.disabled,
    },
  },
  typography: {
    fontFamily: '"Raleway", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      color: colors.darkPurple,
    },
    h2: {
      fontWeight: 600,
      color: colors.darkPurple,
    },
    h3: {
      fontWeight: 600,
      color: colors.darkPurple,
    },
    h4: {
      fontWeight: 600,
      color: colors.darkPurple,
    },
    h5: {
      fontWeight: 500,
      color: colors.darkPurple,
    },
    h6: {
      fontWeight: 500,
      color: colors.darkPurple,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 50,
          padding: '10px 24px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          },
        },
        contained: {
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
          '&:hover': {
            boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
          },
        },
      },
    },
  },
});

export { colors };
export default theme;